module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/crossfilter/index.js
// module id = 879
// module chunks = 0 3 5